import { Input, Select, Table } from "antd";
import { familyDetailsInitialValues } from "./enum";
import { reference } from "../../help-service/enumList";
import { Col, Form, Row } from "react-bootstrap";

const ReferenceTable = ({ errors, details, setDetails, loading }) => {
  const handleChange = (index, field, value) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      return { ...prev, data: updatedData };
    });
  };

  const columns = [
    {
      title: "",
      dataIndex: "sr_no",
      key: "sr_no",
      width: 3,
      align: "center",
      render: (text, record, index) => (
        <div className="fw-semibold">{index + 1}.</div>
      ),
    },
    {
      title: "Reference",
      dataIndex: "itl_reference",
      key: "itl_reference",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Select
            value={text}
            style={{ width: "100%" }}
            placeholder="Reference Type"
            className={`candidate-form-custom-select ${
              errors[index]?.itl_reference ? "error" : ""
            }`}
            onChange={(value) => handleChange(index, "itl_reference", value)}
            options={reference.list}
            disabled
          />

          {/* <Input
            value={text}
            placeholder="Reference"
            className={`${errors[index]?.itl_reference ? "error" : ""}`}
            onChange={(e) =>
              handleChange(index, "itl_reference", e.target.value)
            }
            disabled
          /> */}
          <div className="input-error">{errors[index]?.itl_reference}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Name <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_name",
      key: "itl_name",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Name"
            className={`${errors[index]?.itl_name ? "error" : ""}`}
            onChange={(e) => handleChange(index, "itl_name", e.target.value)}
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_name}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Contact No <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_contact",
      key: "itl_contact",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            type="number"
            value={text}
            placeholder="Contact No"
            className={`${errors[index]?.itl_contact ? "error" : ""}`}
            onChange={(e) => {
              const value = e.target.value;
              handleChange(index, "itl_contact", value.slice(0, 10));
            }}
            disabled={loading}
          />
          <div className="input-error">{errors[index]?.itl_contact}</div>
        </div>
      ),
    },
    {
      title: (
        <span>
          Email <span className="text-danger">*</span>
        </span>
      ),
      dataIndex: "itl_email",
      key: "itl_email",
      render: (text, record, index) => (
        <div className="d-flex flex-column align-items-start">
          <Input
            value={text}
            placeholder="Email"
            className={`${errors[index]?.itl_email ? "error" : ""}`}
            onChange={(e) => handleChange(index, "itl_email", e.target.value)}
            disabled={loading}
            type="email"
          />
          <div className="input-error">{errors[index]?.itl_email}</div>
        </div>
      ),
    },

    // {
    //   title: "Address",
    //   dataIndex: "itl_address",
    //   key: "itl_address",
    //   render: (text, record, index) => (
    //     <div className="d-flex flex-column align-items-start">
    //       <Input
    //         value={text}
    //         placeholder="Address"
    //         className={`${errors[index]?.itl_address ? "error" : ""}`}
    //         onChange={(e) => handleChange(index, "itl_address", e.target.value)}
    //         disabled={loading}
    //       />
    //       <div className="input-error">{errors[index]?.itl_address}</div>
    //     </div>
    //   ),
    // },
    // {
    //   title: "Relationship",
    //   dataIndex: "itl_relationship",
    //   key: "itl_relationship",
    //   render: (text, record, index) => (
    //     <div className="d-flex flex-column align-items-start">
    //       <Input
    //         value={text}
    //         placeholder="Relationship"
    //         className={`${errors[index]?.itl_relationship ? "error" : ""}`}
    //         onChange={(e) =>
    //           handleChange(index, "itl_relationship", e.target.value)
    //         }
    //         disabled={loading}
    //       />
    //       <div className="input-error">{errors[index]?.itl_relationship}</div>
    //     </div>
    //   ),
    // },
  ];

  const handleDelete = (index) => {
    setDetails((prev) => {
      const updatedData = [...prev.data];
      const deletedItem = updatedData[index];
      updatedData.splice(index, 1);

      const updatedDeletedData = [...prev.deletedData];
      if (deletedItem?.itl_familydetailid) {
        updatedDeletedData.push(deletedItem.itl_familydetailid);
      }

      return {
        ...prev,
        data: updatedData,
        deletedData: updatedDeletedData,
      };
    });
  };

  const handleAddNewRow = () => {
    setDetails((prev) => ({
      ...prev,
      data: [...prev.data, { ...familyDetailsInitialValues }],
    }));
  };

  return (
    <div>
      <h5 className="d-none d-lg-block">Reference of two known persons</h5>
      <h5 className="d-lg-none">References</h5>
      {/* <div className="d-flex justify-content-end mt-3">
        <Button type="primary" onClick={handleAddNewRow} disabled={loading}>
          <Plus style={{ height: "15px", width: "15px" }} />
          Add Member
        </Button>
      </div> */}

      <hr />

      <div className="d-none d-lg-block">
        <Table
          size="small"
          columns={columns}
          dataSource={details.data}
          pagination={false}
          scroll={{ x: "max-content" }}
          className="custom-candidate-form-table"
        />
      </div>

      {/* Mobile view */}
      <div className="d-lg-none">
        {details.data.map((item, index) => (
          <div key={index} className="">
            <Form.Group className="mb-2">
              <Form.Label className=" fw-semibold">
                {index + 1}. {reference.text[item.itl_reference]}
              </Form.Label>
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    value={item.itl_name}
                    className={`${errors[index]?.itl_name ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_name", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">{errors[index]?.itl_name}</div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="required fw-semibold">
                    Contact No
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Contact No"
                    value={item.itl_contact}
                    className={`${errors[index]?.itl_contact ? "error" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleChange(index, "itl_contact", value.slice(0, 10));
                    }}
                    disabled={loading}
                  />
                  <div className="input-error">
                    {errors[index]?.itl_contact}
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="required fw-semibold">
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={item.itl_email}
                    className={`${errors[index]?.itl_email ? "error" : ""}`}
                    onChange={(e) =>
                      handleChange(index, "itl_email", e.target.value)
                    }
                    disabled={loading}
                  />
                  <div className="input-error">{errors[index]?.itl_email}</div>
                </Form.Group>
              </Col>
            </Row>
            {index < details.data.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferenceTable;
